import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

const useRedirectUrl = () : string => {
  const [redirectUrl, setRedirectUrl] = useState('');
  const { search } = useLocation();
  useEffect(() => {
    const queryString = new URLSearchParams(search);
    setRedirectUrl(typeof queryString.get('redirectUrl') === 'string' ?
      decodeURIComponent(queryString.get('redirectUrl') || '') :
      '');
  }, []); 
  return redirectUrl;
};

export default useRedirectUrl;